import { useQuery } from 'hooks/useCustomQuery';
import { getAssignedPlans } from 'API/Company/getAssignedPlans';

const useGetAssignedPlans = (currentCompany, setAssignedPlans) => {
    return useQuery({
        queryKey: ['assignedPlans'],
        queryFn: async () => {
            const data = await getAssignedPlans(currentCompany).then((res) => {
                setAssignedPlans(
                    res.concat({ name: '–Company Default–', id: null }),
                );
                return res;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !!currentCompany,
        staleTime: 0,
    });
};

export default useGetAssignedPlans;
